var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('a',{attrs:{"href":"https://www.smartipms.com","target":"_blank"}},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-share"}},[_vm._v(" 景隆PMS数据平台 ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }